import React from "react";

export default function UserImage({ url }) {
  return (
    <div
      className="rounded bg-light d-flex justify-content-center align-items-center"
      style={{ width: "16rem", height: "16rem" }}
    >
      {url ? (
        <img src={url} alt="Profile" />
      ) : (
        <p className="m-0 fw-semibold opacity-25">No Image</p>
      )}
    </div>
  );
}
